'use client';

import ShareButton from './ShareButton';
import CopyToClipboard from './CopyToClipboard';
import { ShareButtonProps } from './types';

interface ShareLinksProps {
  title: string;
  slug: string;
}

const BASE_URL = 'https://www.chime.com/';

const ShareLinks = ({ title, slug }: ShareLinksProps) => {
  const pageUrl = `${BASE_URL}${slug}`;
  const shareUrl = encodeURIComponent(pageUrl);
  const shareTitle = encodeURIComponent(title);

  const shareButtons: ShareButtonProps[] = [
    {
      name: 'LinkedIn',
      link: `https://www.linkedin.com/shareArticle?mini=true&url=${shareUrl}&title=${shareTitle}`,
      testId: 'linkedin-button',
    },
    {
      name: 'Twitter',
      link: `https://twitter.com/intent/tweet?url=${shareUrl}`,
      testId: 'twitter-button',
    },
    {
      name: 'Threads',
      link: `https://www.threads.net/intent/post?url=${shareUrl}`,
      testId: 'threads-button',
    },
    {
      name: 'Facebook',
      link: `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}&quote=${shareTitle}`,
      testId: 'facebook-button',
    },
  ];

  return (
    <div data-testid="share-links" className="flex items-center gap-2">
      <p className="font-[570] text-content-primary mr-1">Share:</p>

      {shareButtons.map(item => (
        <ShareButton key={item.name} {...item} />
      ))}

      <CopyToClipboard linkToCopy={pageUrl} />
    </div>
  );
};

export default ShareLinks;
